import { assocPath, mergeDeepRight } from 'ramda'
import thunk from 'redux-thunk'
import { createReducer } from 'reduxsauce'

import FetchingMiddleware from '../services/FetchingMiddleware'
import type { ClientStateType } from '../types/ClientStateType'
import { mergeValuesInArray } from '../utilities/reduxHelpers'
import { createTypedActions } from './redux.utils'

const THERAPISTS_BEFORE_FILLED = [
  { placeholder: 1, visible: true },
  { placeholder: 2, visible: true },
  { placeholder: 3, visible: true },
  { placeholder: 4, visible: true },
  { placeholder: 5, visible: true },
  { placeholder: 6, visible: true },
]

/* ------------- Types and Action Creators ------------- */

// ENUMS
export const CELL_DURATION = 60

export enum FEEDBACK_STATUS {
  happy,
  neutral,
  unhappy,
}

export const FEEDBACK_SPECIFICATIONS_ENUMS = {
  status: {
    [FEEDBACK_STATUS.happy]: 'feedbackClientHappySpec',
    [FEEDBACK_STATUS.neutral]: 'feedbackClientNeutralSpec',
    [FEEDBACK_STATUS.unhappy]: 'feedbackClientUnhappySpec',
  },
  reason: {
    '0': 'feedbackClientUnhappyMessageSpec',
    '1': 'feedbackClientUnhappyMessageSpec',
    '2': 'feedbackClientUnhappyMessageSpec',
  },
}

export const FEEDBACK_SPECIFICATIONS_EDIT_ENUMS = {
  status: {
    [FEEDBACK_STATUS.happy]: 'feedbackClientHappySpecEdit',
    [FEEDBACK_STATUS.neutral]: 'feedbackClientHappySpecEdit',
    [FEEDBACK_STATUS.unhappy]: 'feedbackClientHappySpecEdit',
  },
  reason: {
    '0': 'feedbackClientUnhappyMessageSpec',
    '1': 'feedbackClientUnhappyMessageSpec',
    '2': 'feedbackClientUnhappyMessageSpec',
  },
}

export const SHOW_THERAPISTS = {
  ALL: 0,
  ABSOLVED_THERAPIST: 1,
}

export const REQUIRED_FEEDBACK_ENUMS = ['first']

const ACTIONS = {
  onChangeClientValue: ['path', 'value'],
  onMergeClientValue: ['value'],
  mergeClientValuesInArray: ['path', 'value'],
  updateTherapistFeedbackRequest: ['feedback'],
  getTherapistsRequest: null,
  getTherapistReviewsRequest: ['therapistId', 'therapistUserId', 'userType'],
  getTherapistDetailRequest: ['therapistId'],
  cancelPrebookedEventsRequest: ['eventsId'],
}

const { Types, Creators } = createTypedActions<keyof typeof ACTIONS>(ACTIONS)

// ======================================================
// Middleware Configuration
// ======================================================
const middleware = [thunk]

middleware.push(FetchingMiddleware as any)

const ClientActions = Creators
export const ClientTypes = Types
export default ClientActions

/* ------------- Initial State ------------- */

export const INITIAL_STATE = {
  feedback: {},
  diagnosisTest: false,
  recentlyVisitedTherapist: null,
  favouredTherapists: [],
  reviews: {},
  appointments: [],
  reservationModalVisible: false,
  freeTherapists: THERAPISTS_BEFORE_FILLED,
  showTherapists: SHOW_THERAPISTS.ABSOLVED_THERAPIST,
}

/* ------------- Reducers ------------- */

export const onChangeClientValueR = (
  state: ClientStateType,
  { path, value }: { path: string; value: object | string | boolean | number },
): ClientStateType => assocPath(path.split('.'), value, state)

export const onMergeClientValueR = (
  state: ClientStateType,
  { value }: { value: object | boolean | number | string },
): ClientStateType => mergeDeepRight(state, value)

export const mergeClientValuesInArrayR = (
  state: ClientStateType,
  { path, value }: { path: string; value: object | string | boolean | number },
): ClientStateType => mergeValuesInArray(state, path, value)

/* ------------- Hookup Reducers To Types ------------- */

export const reducer = createReducer(INITIAL_STATE, {
  [Types.ON_CHANGE_CLIENT_VALUE]: onChangeClientValueR,
  [Types.ON_MERGE_CLIENT_VALUE]: onMergeClientValueR,
  [Types.MERGE_CLIENT_VALUES_IN_ARRAY]: mergeClientValuesInArrayR,
  [Types.UPDATE_THERAPIST_FEEDBACK_REQUEST]: (state) => state,
  [Types.GET_THERAPISTS_REQUEST]: (state) => state,
  [Types.GET_THERAPIST_REVIEWS_REQUEST]: (state) => state,
  [Types.GET_THERAPIST_DETAIL_REQUEST]: (state) => state,
  [Types.CANCEL_PREBOOKED_EVENTS_REQUEST]: (state) => state,
} as any)
